import i18next from 'i18next';
import React from 'react';
import styled from 'styled-components';

import {Button} from '@famly/mf_input_button';
import {Icon} from '@famly/mf_data-display_icon';
import {Text} from '@famly/mf_data-display_text';
import {Stack, createStack} from '@famly/mf_layout_stack';
import {Box} from '@famly/mf_layout_box';
import {ModalBody, ModalHeader, ModalTopBar, PortalModal} from 'web-app/react/components/modals/modals';

import type {HandleSimplifiedUSBillingPlanModalWithTemplates, Template} from '../types';
import {toLowerCaseWithoutWhitespaces} from '../helpers/helpers';

const Template = styled(
    createStack({
        p: 4,
        borderBottom: 'n200',
        spacing: 4,
        alignItems: 'center',
        cursor: 'pointer',
    }),
)`
    &:hover {
        background-color: ${props => props.theme.mf.colorPalette.n50};
    }
`;

type Props = {
    onClose: VoidFunction;
    handleSimplifiedUSBillingPlanModalWithTemplates: HandleSimplifiedUSBillingPlanModalWithTemplates;
    templates: Array<Template>;
};

export const PlanTemplatesModal = ({onClose, handleSimplifiedUSBillingPlanModalWithTemplates, templates}: Props) => {
    return (
        <PortalModal type="big" data-e2e-id="plan-templates-modal">
            <Box padding={3}>
                <ModalTopBar onCloseModal={onClose}>
                    <ModalHeader
                        header={i18next.t('react.simplifiedUsBillingPlan.translations.json.templates.addPlan')}
                    />
                </ModalTopBar>
                <ModalBody>
                    <Stack justifyContent="space-between">
                        <Button
                            data-e2e-id="start-from-scratch-button"
                            variant="secondary"
                            icon="add"
                            text={i18next.t(
                                'react.simplifiedUsBillingPlan.translations.json.templates.startFromScratch',
                            )}
                            onClick={() => handleSimplifiedUSBillingPlanModalWithTemplates(undefined, undefined)}
                        />
                        <Stack borderLeft="n200" direction="column" pl={10} width="64%">
                            <Text variant="body" emphasized mb={2}>
                                {i18next.t('react.simplifiedUsBillingPlan.translations.json.templates.chooseTemplate')}
                            </Text>
                            {templates.map(template => {
                                return (
                                    <Template
                                        key={template.title}
                                        onClick={() =>
                                            handleSimplifiedUSBillingPlanModalWithTemplates(templates, template.id)
                                        }
                                    >
                                        <Icon name="article" />
                                        <Text
                                            variant="body"
                                            data-e2e-id={`plan-template-${toLowerCaseWithoutWhitespaces(
                                                template.title,
                                            )}`}
                                        >
                                            {template.title}
                                        </Text>
                                    </Template>
                                );
                            })}
                        </Stack>
                    </Stack>
                </ModalBody>
            </Box>
        </PortalModal>
    );
};
